import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import Landing from './pages/Landing';
import Battle from './pages/Battle';
import History from './pages/History';
import ShareReport from './pages/ShareReport';
import { auth } from './lib/firebase';
import { useAuthStore } from './lib/authStore';
import './App.css';

/**
 * Syncs Firebase auth state into the Zustand store globally.
 * Placed inside Router so it renders once on mount.
 */
function AuthSync() {
  const { login, logout, isAuthenticated } = useAuthStore();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        if (!isAuthenticated) {
          try { await login(firebaseUser); } catch {}
        }
      } else {
        if (isAuthenticated) logout();
      }
    });
    return unsub;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

/**
 * Redirects unauthenticated users to the landing page.
 * The Landing page handles surfacing the AuthModal automatically.
 */
function RequireAuth({ children }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  if (!isAuthenticated) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <Router>
      <AuthSync />
      <div className="app-root">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route
            path="/battle/:battleId"
            element={<RequireAuth><Battle /></RequireAuth>}
          />
          <Route
            path="/history"
            element={<RequireAuth><History /></RequireAuth>}
          />
          {/* Public share route — no auth required */}
          <Route path="/share/:token" element={<ShareReport />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}
